import Vue from 'vue';

const state = () => ({
    email: '',
    phone: ''
});

const getters = {};

const actions = {
    setEmail({ commit }, email) {
        return commit('SET_EMAIL', email)
    },
    setPhone({ commit }, phone) {
        return commit('SET_PHONE', phone)
    },
    removeData({ commit }) {
        return commit('REMOVE_GUEST')
    }
};

const mutations = {
    SET_EMAIL(state, email) {
        localStorage.setItem('guest_email', email);
        Vue.prototype.$cookies.set('guest_email', email, null, null, "sharedcharter.com");
        state.email = email;
    },
    SET_PHONE(state, phone) {
        localStorage.setItem('guest_phone', phone);
        Vue.prototype.$cookies.set('guest_phone', phone, null, null, "sharedcharter.com");
        state.phone = phone;
    },
    REMOVE_GUEST(state) {
        localStorage.removeItem('guest_email')
        localStorage.removeItem('guest_phone')
        Vue.prototype.$cookies.remove('guest_email');
        Vue.prototype.$cookies.remove('guest_phone');
        state.email = ''
        state.phone = ''
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}